import React from "react";
import { Button, Modal, Label } from "semantic-ui-react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import CustomTextareaComponent from "components/Form/CustomTextareaComponent";
import ShortcutComment from "components/Others/ShortcutComment";

const schemaValidation = Yup.object().shape({
	canceled_reason: Yup.string().required("Champ requis"),
});

const CancelFolderModal = ({ open, close, submit }) => {
	return (
		<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
			<Modal.Header>Motif de l'annulation</Modal.Header>
			<Formik
				enableReinitialize
				initialValues={{
					canceled_reason: "",
				}}
				validationSchema={schemaValidation}
				onSubmit={(values) => {
					submit(values.canceled_reason);
					close();
				}}
			>
				{({ submitForm, values, setFieldValue }) => (
					<>
						<Modal.Content>
							<Form>
								<Field component={CustomTextareaComponent} name="canceled_reason" customlabel="Veuillez saisir le motif de l'annulation" required />
								{/* <ShortcutComment
									setFieldValue={setFieldValue}
									fieldName="canceled_reason"
									fieldValue={values.canceled_reason}
									comments={["Test IT"]}
								/> */}
							</Form>
						</Modal.Content>

						<Modal.Actions>
							<Button
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									close();
								}}
							>
								Annuler
							</Button>
							<Button
								primary
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									submitForm();
								}}
							>
								Confirmer
							</Button>
						</Modal.Actions>
					</>
				)}
			</Formik>
		</Modal>
	);
};

export default CancelFolderModal;
